"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheSlutOptions = void 0;
/** TheSlutOptions.tsx
 *
 * Game Options for TheSlut.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.TheSlutOptions = {
    versions: [
        {
            title: "9 Card",
            description: "(7 cards after players discard 2) | 4 Player Cards, MUST USE 2. | 5 Comm. Cards, MUST USE 3.",
            value: CardVersionSetting_1.CardVersionSetting.NINE_CARD,
            flavor: 9,
            default: true,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
        // {
        //     title: "7 Card",
        //     description: "2 Player Cards, MUST USE BOTH. | 5 Comm. Cards, MUST USE 3.",
        //     value: CardVersionSetting.SEVEN_CARD,
        //     default: true
        // }
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [defaultOptions_1.optionNoneDefault],
    wildcards: [defaultOptions_1.wildcardNoneDefault, defaultOptions_1.wildcardDeuces, defaultOptions_1.wildcardOneEyedJacks],
};
//# sourceMappingURL=TheSlutOptions.js.map